import { LinkItem, LinksSet } from 'components/layout/NavBar/types';
import ChatSvg from 'components/svg/ChatSvg';
import EmailSvg from 'components/svg/EmailSvg';
import FileSvg from 'components/svg/FileSvg';
import HatSvg from 'components/svg/HatSvg';
import InflGlobusSvg from 'components/svg/InflGlobusSvg';
import MainSvg from 'components/svg/MainSvg';
import ManagersSvg from 'components/svg/ManagersSvg';
import NavBasketSvg from 'components/svg/NavBasketSvg';
import SearchSvg from 'components/svg/SearchSvg';
import SupportSvg from 'components/svg/SupportSvg';
import { ItemsNotificationType } from 'data/interfaces/INotification';
import { ProfileType } from 'data/interfaces/IRegistration';
import { TELEGRAM_SUPPORT_LINK } from 'types/constants';

const linksSet: LinksSet = {
  main: {
    path: '/',
    text: 'nav_main',
    icon: <MainSvg />,
  },
  search: {
    path: '/recruiting',
    text: 'nav_search',
    icon: <SearchSvg />,
  },
  cvs: {
    path: '/cvs',
    text: 'nav_myCvs',
    icon: <FileSvg />,
  },
  vacancies: {
    path: '/vacancies',
    text: 'nav_myVacancies',
    icon: <FileSvg />,
  },
  messages: {
    path: '/messenger',
    text: 'nav_messenger',
    icon: <ChatSvg />,
    iconActive: <ChatSvg isActive={true} />,
    notificationType: ItemsNotificationType.ChatMessage,
  },
  shop: {
    path: '/shop',
    text: 'nav_shop',
    icon: <NavBasketSvg />,
  },
  knowledge: {
    path: '/base',
    text: 'nav_knowlegdeBase',
    icon: <HatSvg />,
  },
  support: {
    path: TELEGRAM_SUPPORT_LINK,
    text: 'nav_support',
    icon: <SupportSvg />,
  },
  managers: {
    path: '/managers',
    text: 'nav_managers',
    icon: <ManagersSvg />,
  },
  feedbacks: {
    path: '/profile',
    query: { page: 'feedbacks' },
    text: 'nav_myFeedbacks',
    icon: <EmailSvg />,
  },
  influencer_cvs: {
    path: '/influencer_cvs',
    text: 'Influence Hub',
    icon: <InflGlobusSvg size='small' />,
    isRawText: true,
  },
  influence_hub: {
    path: '/influence_hub',
    text: 'Influence Hub',
    icon: <InflGlobusSvg size='small' />,
    isRawText: true,
  },
};

export const roleLinks: Record<ProfileType, LinkItem[]> = {
  employee: [
    linksSet.main,
    linksSet.search,
    linksSet.cvs,
    linksSet.feedbacks,
    linksSet.messages,
    linksSet.knowledge,
    linksSet.influencer_cvs,
  ],
  hirer: [
    linksSet.main,
    linksSet.influence_hub,
    linksSet.search,
    linksSet.vacancies,
    linksSet.messages,
    linksSet.shop,
    linksSet.managers,
    linksSet.knowledge,
  ],
};
